<!--
 * @Author: meixianming
 * @Date: 2023-12-13 20:37:47
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-04-01 09:58:12
 * @Description: file content
 * @FilePath: /manage_property/src/views/IntelligentService/Setting/indexList.vue
-->
<template>
  <div class="search-wrap">
    <slot></slot>
    <div class="search-btns">
      <el-button type="primary" @click="toSearch">查询</el-button>
      <el-icon @click="toReset" :size="20">
        <RefreshLeft />
      </el-icon>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['search', 'reset']);

const toSearch = () => {
  emit('search');
}

const toReset = () => {
  emit('reset')
}
</script>

<style lang="scss" scoped>
.search-wrap {
  display: flex;
  align-items: flex-end;

  :deep(.el-form-item__content) {
    width: 220px;
  }

  .search-btns {
    width: auto;
    padding-bottom: 18px;
    display: flex;
    align-items: center;

    button,
    i {
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
</style>
